import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-navy-900 border-t border-navy-800 py-12 text-center text-gray-400 text-sm" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="mb-6" data-id="element-3">
          <img src="https://cdn.magicpatterns.com/uploads/fNNGgjWmozxhDdTNVaVMHb/plenava_logo.png" alt="Plenava" className="h-16 w-auto mx-auto mb-2" data-id="element-4" />
        </div>
        <div className="flex justify-center space-x-6 mb-8" data-id="element-5">
          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-white transition-colors underline decoration-gray-600 underline-offset-4" data-id="element-6">
            Privacy Policy
          </button>
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-white transition-colors underline decoration-gray-600 underline-offset-4" data-id="element-7">
            Terms & Conditions
          </button>
        </div>

        <p className="text-xs text-gray-500 max-w-2xl mx-auto leading-snug" data-id="element-8">
          Disclaimer: The information provided in this digital product is for
          educational purposes only and is not intended as medical advice.
          Always consult with a qualified healthcare professional before making
          significant changes to your diet or lifestyle, especially if you have
          a medical condition like Type 1 Diabetes.
        </p>
        <p className="mt-4 text-xs text-gray-600" data-id="element-9">
          &copy; {new Date().getFullYear()} Plenava. All rights reserved.
        </p>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Privacy Policy" data-id="element-10">
        <p data-id="element-11">
          <strong data-id="element-12">Last Updated:</strong> {new Date().toLocaleDateString()}
        </p>
        <p data-id="element-13">
          At Plenava, we are committed to protecting your privacy. This Privacy
          Policy outlines how we collect, use, and safeguard your personal
          information when you purchase our digital products, including "The
          48-Hour Glucose Reset" ebook.
        </p>

        <h3 className="font-bold text-lg mt-4 text-navy-900" data-id="element-14">
          1. Information We Collect
        </h3>
        <p data-id="element-15">
          When you make a purchase, we collect your name, email address, and
          payment information necessary to process your transaction and deliver
          the digital product.
        </p>

        <h3 className="font-bold text-lg mt-4 text-navy-900" data-id="element-16">
          2. How We Use Your Information
        </h3>
        <p data-id="element-17">
          We use your information solely to deliver the purchased digital
          products, provide customer support, and occasionally send updates
          related to your purchase. We do not sell or rent your personal
          information to third parties.
        </p>

        <h3 className="font-bold text-lg mt-4 text-navy-900" data-id="element-18">3. Contact Us</h3>
        <p data-id="element-19">
          If you have any questions about this Privacy Policy, please contact us
          at <strong data-id="element-20">plenavaweb@gmail.com</strong>.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Terms & Conditions" data-id="element-21">
        <p data-id="element-22">
          <strong data-id="element-23">Last Updated:</strong> {new Date().toLocaleDateString()}
        </p>
        <p data-id="element-24">
          Welcome to Plenava. By purchasing "The 48-Hour Glucose Reset" digital
          bundle, you agree to the following terms and conditions.
        </p>

        <h3 className="font-bold text-lg mt-4 text-navy-900" data-id="element-25">
          1. Digital Product Delivery
        </h3>
        <p data-id="element-26">
          Upon successful payment, you will receive instant access to download
          the digital PDF bundle. Due to the nature of digital products, all
          sales are final once the download link has been accessed.
        </p>

        <h3 className="font-bold text-lg mt-4 text-navy-900" data-id="element-27">
          2. Intellectual Property
        </h3>
        <p data-id="element-28">
          The content provided in this ebook is the intellectual property of
          Plenava. You are granted a single-user license for personal use only.
          You may not distribute, reproduce, or resell any part of this digital
          product.
        </p>

        <h3 className="font-bold text-lg mt-4 text-navy-900" data-id="element-29">
          3. Medical Disclaimer
        </h3>
        <p data-id="element-30">
          The information contained in this product is for educational purposes
          only and does not substitute professional medical advice. Consult your
          physician before beginning any new dietary protocol.
        </p>

        <h3 className="font-bold text-lg mt-4 text-navy-900" data-id="element-31">
          4. Contact Information
        </h3>
        <p data-id="element-32">
          For support or inquiries regarding these terms, please contact us at{' '}
          <strong data-id="element-33">plenavaweb@gmail.com</strong>.
        </p>
      </Modal>
    </footer>;
}